import Snappy from '../../../libs/snappy/snappy';

Snappy.Component.Tickets = class Tickets extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-tickets';
	}

	constructor(element) {
		super(element);
	}

	render() {
		this.setVars();
		this.setEventListeners();
		this.fitContext();
		this.initCarousel();
	}

	setVars() {
		this.isBelowFullWidthComponent = this.determineComponentContext();
		this.$carouselComponent = this.$element.find('.fa-carousel');
		this.$carousel = this.$carouselComponent.find('.carousel');
		this.carouselInstance = this.$carouselComponent.get(0).component;
	}

	setEventListeners() {
		window.addEventListener('fa.viewportResize', this.onViewportResize.bind(this));
	}

	determineComponentContext() {
		this.$parentElement = this.$element.parent();

		return this.$parentElement.hasClass('col-sm-4');
	}

	fitContext() {
		const containerClass = 'container';
		const narrowClass = 'narrow-variation';

		if (this.isBelowFullWidthComponent) {
			this.$element.find(`.${containerClass}`).removeClass(containerClass).addClass(narrowClass);
			this.$element.addClass(narrowClass);
			this.carouselInstance.options.slidesToShow = 1;
			this.setElementWidth();
		}
	}

	setElementWidth() {
		this.parentWidth = this.$parentElement.width();
		this.$element.width(this.parentWidth);
	}

	initCarousel() {
		this.$carousel.slick(this.carouselInstance.options);
		this.carouselInitialized = true;
	}

	onViewportResize() {
		this.setElementWidth();
	}
};



// WEBPACK FOOTER //
// ./components/tickets/scripts/tickets.js